import { render, staticRenderFns } from "./AShareMarketCapGDP.vue?vue&type=template&id=d58df56e&scoped=true"
import script from "./AShareMarketCapGDP.vue?vue&type=script&lang=js"
export * from "./AShareMarketCapGDP.vue?vue&type=script&lang=js"
import style0 from "./AShareMarketCapGDP.vue?vue&type=style&index=0&id=d58df56e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58df56e",
  null
  
)

export default component.exports